import { IGenericCmsPage } from "api/interfaces/static-pages/common.type";
import Index from "container/rapid-delivery/RapidDelivery";
function RapidDelivery(props: IGenericCmsPage) {
  return <Index {...props} />;
}
export default RapidDelivery;
